import {css} from '@emotion/react';
import {motion} from 'framer-motion';
import {useMemo} from 'react';

const height = 18;
const width = 32;

const toggleWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 0.9em;
`;

const toggleOuterStyle = css`
  flex: 0 0 auto;
  width: ${width}px;
  height: ${height}px;
  position: relative;
  border-radius:  999px;
  transition: background-color 0.2s ease-out;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);
`;

const toggleInnerStyle = css`
  position: absolute;
  margin-top: 2px;
  width: ${height - 4}px;
  height: ${height - 4}px;
  background: #fff linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  border-radius: 50%;
`;

export const Toggle = ({className, onChange, value, label, disabled}) => {
  const onClick = useMemo(() => {
    if (!onChange) {
      return undefined;
    }

    return () => {
      onChange(!value);
    };
  }, [onChange, value]);

  const onKeyPress = useMemo(() => {
    if (!onChange) {
      return undefined;
    }

    return ({key}) => {
      if (key === 'Enter') {
        onChange(!value);
      }
    };
  }, [onChange, value]);

  let backgroundColor = value ? '#0B5CD7' : '#757575';
  let cursor = onChange ? 'pointer' : undefined;

  if (disabled === true) {
    backgroundColor = value === true ? '#6ea1f0' : '#b7b7b7';
    cursor = 'not-allowed';
  }

  return (
    <div
      className={className}
      onClick={onClick}
      onKeyPress={onKeyPress}
      role={onChange ? 'button' : undefined}
      tabIndex={onChange ? 0 : undefined}
      css={toggleWrapperStyle}
      style={{cursor}}
    >
      <motion.div
        animate={{backgroundColor}}
        transition={{
          ease: 'easeOut',
          duration: 0.2,
        }}
        initial={false}
        css={toggleOuterStyle}
        style={{marginRight: label ? '1em' : undefined}}
      >
        <motion.div
          animate={{left: value ? width - height + 2 : 2}}
          transition={{
            ease: 'easeOut',
            duration: 0.2,
          }}
          initial={false}
          css={toggleInnerStyle}
        />
      </motion.div>
      {label}
    </div>
  );
};
